import React, { useState, useEffect, useRef } from 'react';
import './JoinOrgPopup.css';
import ViewIconWhite from '../../../assets/LandingPage/Org/viewOrgPrimaryIcon.svg';
import { organizationAPI } from '../../../api/requests/organization/organizationAPI';
import RequestToJoin from './Buttons/RequestToJoin';
import ViewOrganizationPopup from './ViewOrganizations';
import { Box, Button, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { IconButton } from '@mui/material';
import { RoundedButton } from '../../Form';

export default function JoinOrgPopup({ onClose, code }) {
  const [organization, setOrganization] = useState(null);
  const [selectedOrgName, setSelectedOrgName] = useState('');
  const popupRef = useRef();
  const fetchOrganization = async (code) => {
    try {
      const response = await organizationAPI.searchOrganizationByCode(code);
      setOrganization(response);
    } catch (error) {
      console.error('Error fetching suggested organizations:', error);
    }
  };
  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      onClose();
    }
  };

  const openView = (organizationName) => {
    setSelectedOrgName(organizationName);
  };

  useEffect(() => {
    document.body.classList.add('CreateOrgPopup-open');
    window.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.body.classList.remove('CreateOrgPopup-open');
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    fetchOrganization(code);
  }, [code]);

  if (!organization) {
    return null;
  }

  const renderProfilePhoto = ({ logoLink, name }) => {
    if (logoLink) {
      return <img className="ViewOrg-LogoImg" src={logoLink} alt="" />;
    } else {
      const firstNameInitial = name?.charAt(0) || '';

      return (
        <div className="SuggestedOrginitials-container">
          <span>{firstNameInitial}</span>
        </div>
      );
    }
  };
  return (
    <div 
      className="JoinOrgPopup"
      style={{
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(15, 23, 42, 0.4)',
      }}
    >
      <div className="JoinOrgPopup-main" ref={popupRef} style={{ borderRadius: '16px', overflow: 'hidden' }}>
        <IconButton 
          onClick={onClose} 
          sx={{ 
            position: 'absolute', 
            top: '12px', 
            right: '12px',
            bgcolor: '#f8fafc',
            borderRadius: '12px',
            transition: 'all 0.2s ease',
            '&:hover': {
              bgcolor: '#f1f5f9',
              transform: 'scale(1.05)',
            },
          }}
        >
          <CloseRoundedIcon sx={{ color: '#64748b' }} />
        </IconButton>
        <div className="JoinOrgClosePopup-content" style={{ padding: '24px' }}>
          <Typography 
            variant="h5" 
            sx={{ 
              pb: 0, 
              mb: 1,
              fontFamily: 'Poppins',
              fontWeight: 600,
              color: '#0f172a',
            }}
          >
            Join Organizations
          </Typography>
          <Typography 
            sx={{ 
              color: '#64748b', 
              lineHeight: 1.6,
              fontFamily: 'Poppins',
              fontWeight: 400,
            }} 
            variant="subtitle1"
          >
            Explore the featured organizations to be a part of it with groups of people who share a
            team, course or mutual interest by requesting to be a part of it.
          </Typography>
        </div>
        <div style={{ padding: '0 24px 24px 24px' }}>
          <Box 
            height={'250px'} 
            sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              mt: 2,
              bgcolor: '#f8fafc',
              borderRadius: '12px',
              padding: '16px',
              border: '1px solid #e2e8f0',
            }}
          >
            {organization.map((organization) => (
              <div 
                key={organization.id} 
                className="JoinOrg-orgsRow"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  padding: '16px',
                  marginBottom: '12px',
                  border: '1px solid #e2e8f0',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 2px 8px rgba(59, 130, 246, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#e2e8f0';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ borderRadius: '12px', overflow: 'hidden' }}>
                    {renderProfilePhoto({ logoLink: organization.logoLink, name: organization.name })}
                  </div>
                  <div>
                    <Typography
                      sx={{
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        WebkitBoxOrient: 'vertical',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        color: '#0f172a',
                      }}
                      variant="body1"
                    >
                      {organization.name}
                    </Typography>
                    <p 
                      className="JoinOrg-orgsCreator"
                      style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontFamily: 'Poppins',
                        margin: '4px 0 0 0',
                      }}
                    >
                      {organization?.creator?.username || organization?.creatorData?.username || ''}
                    </p>
                  </div>
                </Box>
                <div className="JoinOrg-orgsBtnDiv" style={{ gap: '8px', display: 'flex' }}>
                  <RoundedButton
                    size="small"
                    variant="outlined"
                    onClick={() => openView(organization.name)}
                  >
                    View Org
                    <img src={ViewIconWhite} alt="" style={{ marginLeft: '8px' }} />
                  </RoundedButton>
                  <RequestToJoin
                    disabled={organization?.isAlreadyRequested}
                    OrganizationID={organization?.id}
                  />
                </div>
              </div>
            ))}
          </Box>
          {selectedOrgName && (
            <ViewOrganizationPopup
              selectedOrgName={selectedOrgName}
              setSelectedOrgName={setSelectedOrgName}
              withoutSidebar={'true'}
            />
          )}
        </div>
      </div>
    </div>
  );
}
